/**
 * How a missing staff number is written.
 *
 * A code is optional — contractors, visiting trainers and new joiners whose
 * code has not been issued yet have none. Left to itself, `{user.employeeCode}`
 * renders as nothing, and in a line like `{code} · {email}` that leaves a
 * dangling separator: " · karan@petpooja.com", which reads as a rendering
 * fault rather than as an absence.
 *
 * An em dash in a column, and the segment dropped entirely in a joined line —
 * see `detailLine`.
 */
export const NO_EMPLOYEE_CODE = '—';

/** For a column or a field of its own, where something must occupy the space. */
export function employeeCodeLabel(code: string | null | undefined): string {
  return code?.trim() || NO_EMPLOYEE_CODE;
}

/**
 * Joins the parts of a subtitle, dropping the ones that are not there.
 *
 * `detailLine([code, department])` gives "PP-1024 · Sales", "Sales" when there
 * is no code, and "" when there is neither — rather than " · Sales" or a lone
 * separator sitting under somebody's name.
 */
export function detailLine(parts: (string | null | undefined)[], separator = ' · '): string {
  return parts
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part))
    .join(separator);
}
